export default {
  label: '财务主管',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '财务主管通常负责监督和协调财务部门的日常运作，确保财务活动的合规性和准确性。\n其职责包括会计核算、预算管理、税务筹划、财务报告等',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '负责设置会计科目、凭证和账簿，进行会计核算，包括记账、结账、对账及归档整理档案',
          id: '0-2-1',
        },
        {
          label: '编制月度、季度和年度财务报表及附注，完成年度审计',
          id: '0-2-2',
        },
        {
          label: '负责公司预算编制及管理，提供财务数据支持',
          id: '0-2-3',
        },
        {
          label: '进行税收筹划与管理，完成税务申报及年终汇算清缴',
          id: '0-2-4',
        },
        {
          label: '定期盘点现金、固定资产等财产，并出具相关报告',
          id: '0-2-5',
        },
        {
          label: '完成上级交付的临时工作及其他任务',
          id: '0-2-6',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '本科及以上学历，会计或财务管理相关专业',
          id: '0-3-1',
        },
        {
          label: '至少3年以上财务相关工作经验，持有中级会计师以上职称',
          id: '0-3-2',
        },
        {
          label: '熟练掌握企业会计准则、财经法规和税收法律法规',
          id: '0-3-3',
        },
        {
          label: '熟悉财务软件及办公软件',
          id: '0-3-4',
        },
        {
          label: '具备良好的沟通协调能力和团队合作精神',
          id: '0-3-5',
        }
      ],
    },
    {
      label: '薪资情况',
      id: '0-4',
      children: [
        {
          label: '8000-15000',
          id: '0-4-1',
        },
      ],
    }
  ],
};